import { render } from "./ContributionHistory.vue?vue&type=template&id=5d4a9226&ts=true"
import script from "./ContributionHistory.vue?vue&type=script&lang=ts"
export * from "./ContributionHistory.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__